document.addEventListener("DOMContentLoaded", function () {
    if (typeof window > "u") return;
    const container = document.querySelector("#container"),
        treeTop = document.querySelector("#treeTop"),
        treeBottom = document.querySelector("#treeBottom"),
        tab1CenterImg = document.querySelector("#tab1-cennter-img"),
        tab1CenterText = document.querySelector("#tab1-cennter-text"),
        tab2CenterImg = document.querySelector("#tab2-cennter-img"),
        tab2CenterText = document.querySelector("#tab2-cennter-text"),
        tab3CenterImg = document.querySelector("#tab3-cennter-img"),
        tab3CenterText = document.querySelector("#tab3-cennter-text"),
        tab4CennterText = document.querySelector("#tab4-cennter-text"),
        tab4CennterImg = document.querySelector("#tab4-cennter-img"),
        tab1FirstImg = document.querySelector("#tab1-first-img"),
        tab1ThirdImg = document.querySelector("#tab1-third-img"),
        tab1FourthImg = document.querySelector("#tab1-fourth-img"),
        tab1SecondImg = document.querySelector("#tab1-second-img"),
        tab2FirstImg = document.querySelector("#tab2-first-img"),
        tab2FirstImg_s = document.querySelector("#tab2-first-img_s"),
        tab2FirstImg_2 = document.querySelector("#tab2-first-img_2"),
        tab2FirstImg_3 = document.querySelector("#tab2-first-img_3"),
        tab2ThirdImg = document.querySelector("#tab2-third-img"),
        tab2FourthImg = document.querySelector("#tab2-fourth-img"),
        tab2FourthImg_1 = document.querySelector("#tab2-fourth-img_1"),
        tab2FourthImg_2 = document.querySelector("#tab2-fourth-img_2"),
        tab2SecondImg = document.querySelector("#tab2-second-img"),
        tab2SecondImg_1 = document.querySelector("#tab2-second-img_1"),
        tab3FirstImg = document.querySelector("#tab3-first-img"),
        tab3FirstImg_1 = document.querySelector("#tab3-first-img_1"),
        tab3FirstImg_2 = document.querySelector("#tab3-first-img_2"),
        tab3ThirdImg = document.querySelector("#tab3-third-img"),
        tab3ThirdImg_1 = document.querySelector("#tab3-third-img_1"),
        tab3FourthImg = document.querySelector("#tab3-fourth-img"),
        tab3SecondImg = document.querySelector("#tab3-second-img"),
        tab4FirstImg = document.querySelector("#tab4-first-img"),
        tab4ThirdImg = document.querySelector("#tab4-third-img"),
        tab4SecondImg = document.querySelector("#tab4-second-img"),
        tab4FourthImg = document.querySelector("#tab4-fourth-img"),
        tab1 = document.querySelector("#tab-1"),
        tab2 = document.querySelector("#tab-2"),
        tab3 = document.querySelector("#tab-3"),
        tab4 = document.querySelector("#tab-4"),
        tab1FillPath = document.querySelector("#tab-1-fill-path"),
        tab2FillPath = document.querySelector("#tab-2-fill-path"),
        tab3FillPath = document.querySelector("#tab-3-fill-path"),
        tab4FillPath = document.querySelector("#tab-4-fill-path"),
        topFillPaths = document.querySelectorAll("#treeTopFill svg path"),
        svgPaths = document.querySelectorAll("#treeBottom svg path"),
        blackmuselidaata = document.querySelector("#blackmuselidaata"),
        tab1MainContent = document.querySelector("#tab1-main--content"),
        tab2MainContent = document.querySelector("#tab2-main--content"),
        tab3MainContent = document.querySelector("#tab3-main--content"),
        tab4MainContent = document.querySelector("#tab4-main--content"),
        tab1FirstImgText = document.querySelector("#tab1-first-img-text"),
        tab1SecondImgText = document.querySelector("#tab1-second-img-text"),
        tab1ThirdImgText = document.querySelector("#tab1-third-img-text"),
        tab1FourthImgText = document.querySelector("#tab1-fourth-img-text"),
        tab2FirstImgText = document.querySelector("#tab2-first-img-text"),
        tab2SecondImgText = document.querySelector("#tab2-second-img-text"),
        tab2ThirdImgText = document.querySelector("#tab2-third-img-text"),
        tab2FourthImgText = document.querySelector("#tab2-fourth-img-text"),
        tab3FirstImgText = document.querySelector("#tab3-first-img-text"),
        tab3SecondImgText = document.querySelector("#tab3-second-img-text"),
        tab3ThirdImgText = document.querySelector("#tab3-third-img-text"),
        tab3FourthImgText = document.querySelector("#tab3-fourth-img-text"),
        tab4SecondImgText = document.querySelector("#tab4-second-img-text"),
        tab4ThirdImgText = document.querySelector("#tab4-third-img-text"),
        tab4FirstImgText = document.querySelector("#tab4-first-img-text"),
        tab4FourthImgText = document.querySelector("#tab4-fourth-img-text"),
        tab1Color = tab1 ? tab1.getAttribute("data-color") : "#E5732E",
        tab2Color = tab2 ? tab2.getAttribute("data-color") : "#c16060",
        tab3Color = tab3 ? tab3.getAttribute("data-color") : "#876cbd",
        tab4Color = tab4 ? tab4.getAttribute("data-color") : "#9da863";
        tab1SecondImgText.classList.remove("active"),
        tab2SecondImgText.classList.remove("active"),
        tab3SecondImgText.classList.remove("active"),
        tab4SecondImgText.classList.remove("active"),
        tab1 &&
            ((tab1.style.backgroundColor = tab1Color),
            (tab2.style.backgroundColor = "#623B20"),
            (tab3.style.backgroundColor = "#623B20"),
            (tab4.style.backgroundColor = "#623B20"),
            (tab1FillPath.style.display = "block"),
            (tab2FillPath.style.display = "none"),
            (tab3FillPath.style.display = "none"),
            (tab4FillPath.style.display = "none"),
            tab1.addEventListener("click", () => {
                (tab1.style.backgroundColor = tab1Color),
                    (tab2.style.backgroundColor = "#623B20"),
                    (tab3.style.backgroundColor = "#623B20"),
                    (tab4.style.backgroundColor = "#623B20"),
                    (tab1FillPath.style.display = "block"),
                    (tab2FillPath.style.display = "none"),
                    (tab3FillPath.style.display = "none"),
                    (tab4FillPath.style.display = "none"),
                    svgPaths.forEach((path) => path.setAttribute("fill", tab1Color)),
                    topFillPaths.forEach((path) => path.setAttribute("stroke", tab1Color)),
                    blackmuselidaata.classList.add("active"),
                    tab1MainContent.classList.add("active"),
                    tab2MainContent.classList.remove("active"),
                    tab3MainContent.classList.remove("active"),
                    tab4MainContent.classList.remove("active");
            })),
        tab4 &&
            tab4.addEventListener("click", () => {
                (tab4.style.backgroundColor = tab4Color),
                    (tab3.style.backgroundColor = "#623B20"),
                    (tab2.style.backgroundColor = "#623B20"),
                    (tab1.style.backgroundColor = "#623B20"),
                    (tab4FillPath.style.display = "block"),
                    (tab3FillPath.style.display = "none"),
                    (tab2FillPath.style.display = "none"),
                    (tab1FillPath.style.display = "none"),
                    svgPaths.forEach((path) => path.setAttribute("fill", tab4Color)),
                    topFillPaths.forEach((path) => path.setAttribute("stroke", tab4Color)),
                    blackmuselidaata.classList.remove("active"),
                    tab1MainContent.classList.remove("active"),
                    tab2MainContent.classList.remove("active"),
                    tab3MainContent.classList.remove("active"),
                    tab4MainContent.classList.add("active");
            }),
        tab2 &&
            tab2.addEventListener("click", () => {
                (tab1.style.backgroundColor = "#623B20"),
                    (tab2.style.backgroundColor = tab2Color),
                    (tab3.style.backgroundColor = "#623B20"),
                    (tab4.style.backgroundColor = "#623B20"),
                    (tab1FillPath.style.display = "none"),
                    (tab2FillPath.style.display = "block"),
                    (tab3FillPath.style.display = "none"),
                    (tab4FillPath.style.display = "none"),
                    svgPaths.forEach((path) => path.setAttribute("fill", tab2Color)),
                    topFillPaths.forEach((path) => path.setAttribute("stroke", tab2Color)),
                    blackmuselidaata.classList.remove("active"),
                    tab1MainContent.classList.remove("active"),
                    tab2MainContent.classList.add("active"),
                    tab3MainContent.classList.remove("active"),
                    tab4MainContent.classList.remove("active");
            }),
        tab3 &&
            tab3.addEventListener("click", () => {
                (tab1.style.backgroundColor = "#623B20"),
                    (tab2.style.backgroundColor = "#623B20"),
                    (tab3.style.backgroundColor = tab3Color),
                    (tab4.style.backgroundColor = "#623B20"),
                    (tab1FillPath.style.display = "none"),
                    (tab2FillPath.style.display = "none"),
                    (tab3FillPath.style.display = "block"),
                    (tab4FillPath.style.display = "none"),
                    svgPaths.forEach((path) => path.setAttribute("fill", tab3Color)),
                    topFillPaths.forEach((path) => path.setAttribute("stroke", tab3Color)),
                    blackmuselidaata.classList.remove("active"),
                    tab1MainContent.classList.remove("active"),
                    tab2MainContent.classList.remove("active"),
                    tab3MainContent.classList.add("active"),
                    tab4MainContent.classList.remove("active");
            }),
        !(!container || !treeTop || !treeBottom) &&
            (gsap.registerPlugin(ScrollTrigger),
            gsap.to(treeTop, {
                scrollTrigger: {
                    trigger: container,
                    start: "20% center",
                    end: "80% center",
                    scrub: !0,
                    onUpdate: (self) => {
                        const progress = self.progress * 100;
                        (treeTop.style.clipPath = `polygon(0 0, 100% 0, 100% ${progress}%, 0 ${progress}%)`),
                            progress >= 20
                                ? (tab1CenterImg.classList.add("big-img"),
                                  tab1CenterImg.classList.remove("small-img"),
                                  tab1CenterText.classList.add("active"),
                                  tab2CenterText.classList.add("active"),
                                  tab3CenterText.classList.add("active"),
                                  tab4CennterText.classList.add("active"),
                                  tab2CenterImg.classList.add("big-img"),
                                  tab2CenterImg.classList.remove("small-img"),
                                  tab3CenterImg.classList.add("big-img"),
                                  tab3CenterImg.classList.remove("small-img"),
                                  tab4CennterImg.classList.add("big-img"),
                                  tab4CennterImg.classList.remove("small-img"))
                                : (tab1CenterImg.classList.add("small-img"),
                                  tab1CenterImg.classList.remove("big-img"),
                                  tab1CenterText.classList.remove("active"),
                                  tab2CenterText.classList.remove("active"),
                                  tab3CenterText.classList.remove("active"),
                                  tab4CennterText.classList.remove("active"),
                                  tab2CenterImg.classList.remove("big-img"),
                                  tab2CenterImg.classList.add("small-img"),
                                  tab3CenterImg.classList.remove("big-img"),
                                  tab3CenterImg.classList.add("small-img"),
                                  tab4CennterImg.classList.add("small-img"),
                                  tab4CennterImg.classList.remove("big-img"));
                    },
                },
            }),
            gsap.to(treeBottom, {
                scrollTrigger: {
                    trigger: container,
                    start: "40% center",
                    end: "60% center",
                    scrub: !0,
                    onUpdate: (self) => {
                        const progress = self.progress * 100;
                        (treeBottom.style.clipPath = `polygon(0 0, 100% 0, 100% ${Math.max(progress, 0)}%, 0 ${Math.max(progress, 0)}%)`),
                            progress >= 52
                                ? (tab1FirstImg.classList.add("big-img"),
                                  tab1FirstImg.classList.remove("small-img"),
                                  tab2FirstImg.classList.add("big-img"),
                                  tab2FirstImg_s.classList.add("big-img"),
                                  tab2FirstImg_s.classList.remove("small-img"),
                                  tab2FirstImg_3.classList.add("big-img"),
                                  tab2FirstImg_3.classList.remove("small-img"),
                                  tab2FirstImg_2.classList.add("big-img"),
                                  tab2FirstImg_2.classList.remove("small-img"),
                                  tab2FirstImg.classList.remove("small-img"),
                                  tab3FirstImg.classList.add("big-img"),
                                  tab3FirstImg.classList.remove("small-img"),
                                   tab3FirstImg_1.classList.add("big-img"),
                                  tab3FirstImg_1.classList.remove("small-img"),
                                   tab3FirstImg_2.classList.add("big-img"),
                                  tab3FirstImg_2.classList.remove("small-img"),
                                  tab4FirstImg.classList.add("big-img"),
                                  tab4FirstImg.classList.remove("small-img"),
                                  tab1FirstImgText.classList.add("active"),
                                  tab2FirstImgText.classList.add("active"),
                                  tab3FirstImgText.classList.add("active"),
                                  tab4FirstImgText.classList.add("active"))
                                : (tab1FirstImg.classList.add("small-img"),
                                  tab1FirstImg.classList.remove("big-img"),
                                  tab2FirstImg.classList.add("small-img"),
                                  tab2FirstImg.classList.remove("big-img"),
                                  tab2FirstImg_s.classList.add("small-img"),
                                  tab2FirstImg_s.classList.remove("big-img"),
                                  tab2FirstImg_2.classList.add("small-img"),
                                  tab2FirstImg_2.classList.remove("big-img"),
                                     tab2FirstImg_3.classList.add("small-img"),
                                  tab2FirstImg_3.classList.remove("big-img"),
                                  tab3FirstImg.classList.add("small-img"),
                                  tab3FirstImg.classList.remove("big-img"),
                                  tab3FirstImg_1.classList.add("small-img"),
                                  tab3FirstImg_1.classList.remove("big-img"),
                                  tab3FirstImg_2.classList.add("small-img"),
                                  tab3FirstImg_2.classList.remove("big-img"),
                                  tab4FirstImg.classList.add("small-img"),
                                  tab4FirstImg.classList.remove("big-img"),
                                  tab1FirstImgText.classList.remove("active"),
                                  tab2FirstImgText.classList.remove("active"),
                                  tab3FirstImgText.classList.remove("active"),
                                  tab4FirstImgText.classList.remove("active")),
                            progress >= 62
                                ? (tab1ThirdImg.classList.add("big-img"),
                                  tab1ThirdImg.classList.remove("small-img"),
                                  tab2ThirdImg.classList.add("big-img"),
                                  tab2ThirdImg.classList.remove("small-img"),
                                  tab3ThirdImg.classList.add("big-img"),
                                  tab3ThirdImg.classList.remove("small-img"),
                                  tab3ThirdImg_1.classList.add("big-img"),
                                  tab3ThirdImg_1.classList.remove("small-img"),
                                  tab1FourthImgText.classList.add("active"),
                                  tab2FourthImgText.classList.add("active"),
                                  tab3FourthImgText.classList.add("active"),
                                  tab4FourthImgText.classList.add("active"))
                                : (tab1ThirdImg.classList.add("small-img"),
                                  tab1ThirdImg.classList.remove("big-img"),
                                  tab2ThirdImg.classList.add("small-img"),
                                  tab2ThirdImg.classList.remove("big-img"),
                                  tab3ThirdImg.classList.add("small-img"),
                                  tab3ThirdImg.classList.remove("big-img"),
                                  tab3ThirdImg_1.classList.add("small-img"),
                                  tab3ThirdImg_1.classList.remove("big-img"),
                                  tab1FourthImgText.classList.remove("active"),
                                  tab2FourthImgText.classList.remove("active"),
                                  tab3FourthImgText.classList.remove("active"),
                                  tab4FourthImgText.classList.remove("active")),
                            progress >= 65
                                ? (tab1FourthImg.classList.add("big-img"),
                                  tab1FourthImg.classList.remove("small-img"),
                                  tab2FourthImg.classList.add("big-img"),
                                  tab2FourthImg.classList.remove("small-img"),
                                  tab2FourthImg_1.classList.add("big-img"),
                                  tab2FourthImg_1.classList.remove("small-img"),
                                  tab2FourthImg_2.classList.add("big-img"),
                                  tab2FourthImg_2.classList.remove("small-img"),
                                  tab3FourthImg.classList.add("big-img"),
                                  tab3FourthImg.classList.remove("small-img"),
                                  tab4FourthImg.classList.add("big-img"),
                                  tab4FourthImg.classList.remove("small-img"),
                                  tab4ThirdImg.classList.add("big-img"),
                                  tab4ThirdImg.classList.remove("small-img"),
                                  tab1ThirdImgText.classList.add("active"),
                                  tab2ThirdImgText.classList.add("active"),
                                  tab3ThirdImgText.classList.add("active"),
                                  tab4ThirdImgText.classList.add("active"))
                                : (tab1FourthImg.classList.add("small-img"),
                                  tab1FourthImg.classList.remove("big-img"),
                                  tab2FourthImg.classList.add("small-img"),
                                  tab2FourthImg.classList.remove("big-img"),
                                  tab2FourthImg_1.classList.add("small-img"),
                                  tab2FourthImg_1.classList.remove("big-img"),
                                  tab2FourthImg_2.classList.add("small-img"),
                                  tab2FourthImg_2.classList.remove("big-img"),
                                  tab3FourthImg.classList.add("small-img"),
                                  tab3FourthImg.classList.remove("big-img"),
                                  tab4FourthImg.classList.add("small-img"),
                                  tab4FourthImg.classList.remove("big-img"),
                                  tab4ThirdImg.classList.add("small-img"),
                                  tab4ThirdImg.classList.remove("big-img"),
                                  tab1ThirdImgText.classList.remove("active"),
                                  tab2ThirdImgText.classList.remove("active"),
                                  tab3ThirdImgText.classList.remove("active"),
                                  tab4ThirdImgText.classList.remove("active")),
                            progress >= 70
                                ? (tab1SecondImg.classList.add("big-img"),
                                  tab1SecondImg.classList.remove("small-img"),
                                  tab2SecondImg.classList.add("big-img"),
                                  tab2SecondImg.classList.remove("small-img"),
                                  tab2SecondImg_1.classList.add("big-img"),
                                  tab2SecondImg_1.classList.remove("small-img"),
                                  tab3SecondImg.classList.add("big-img"),
                                  tab3SecondImg.classList.remove("small-img"),
                                  tab4SecondImg.classList.add("big-img"),
                                  tab4SecondImg.classList.remove("small-img"),
                                  tab1SecondImgText.classList.add("active"),
                                  tab2SecondImgText.classList.add("active"),
                                  tab3SecondImgText.classList.add("active"),
                                  tab4SecondImgText.classList.add("active"))
                                : (tab1SecondImg.classList.add("small-img"),
                                  tab1SecondImg.classList.remove("big-img"),
                                  tab2SecondImg.classList.add("small-img"),
                                  tab2SecondImg.classList.remove("big-img"),
                                  tab2SecondImg_1.classList.add("small-img"),
                                  tab2SecondImg_1.classList.remove("big-img"),
                                  tab3SecondImg.classList.add("small-img"),
                                  tab3SecondImg.classList.remove("big-img"),
                                  tab4SecondImg.classList.add("small-img"),
                                  tab4SecondImg.classList.remove("big-img"),
                                  tab1SecondImgText.classList.remove("active"),
                                  tab2SecondImgText.classList.remove("active"),
                                  tab3SecondImgText.classList.remove("active"),
                                  tab4SecondImgText.classList.remove("active"));
                    },
                },
            }));
});
//# sourceMappingURL=/cdn/shop/t/21/assets/tree-animation.js.map
